import { FC, ReactElement, ReactNode } from "react";
import {
  FormControl,
  FormLabel,
  InputGroup,
  FormErrorMessage,
  Text,
  InputProps,
} from "@chakra-ui/react";
import { useField } from "formik";
import { sharedProps } from "~/constants";
import { fontSizes } from "~/utils/theme";

const { x1s } = fontSizes;

interface Props extends InputProps {
  children: ReactElement;
  color?: any;
  description?: string;
  hideLabel?: boolean;
  id: string;
  inputLeftElement?: ReactNode;
  inputRightElement?: ReactNode;
  label?: string;
  labelProps?: any;
  labelVariant?: string;
  meta: ReturnType<typeof useField>[1];
  minH?: string;
  name?: string;
  placeholder?: string;
  type: string;
}

export const InputWrapper: FC<Props> = ({
  children,
  color = "inherit",
  description,
  hideLabel = false,
  id,
  inputLeftElement,
  inputRightElement,
  label,
  labelProps,
  labelVariant,
  meta,
  minH = "8rem",
  type,
  ...props
}) => {
  return (
    <FormControl isInvalid={meta.touched && !!meta.error} minH={minH}>
      {!hideLabel && (
        <FormLabel
          color={color}
          fontSize={sharedProps.formLabel.default.fontSize}
          htmlFor={id}
          variant={labelVariant}
          {...labelProps}
        >
          {label}
        </FormLabel>
      )}
      {description && (
        <Text color={color} fontSize={x1s} textAlign="initial">
          {description}
        </Text>
      )}
      <InputGroup {...props}>
        {inputLeftElement}
        {children}
        {inputRightElement}
      </InputGroup>
      <FormErrorMessage color="th.danger1">{meta.error}</FormErrorMessage>
    </FormControl>
  );
};
